<ng-container *ngIf="opened">
  <kendo-dialog
    [title]="referenceDataLabels.GdprModalTitle | localizeLabel"
    (close)="close()"
    [width]="700"
    [height]="600"
    class="vo-modal"
  >
    <img class="d-block mb-30 mx-auto" [src]="logoPath" />
    <div class="vo-heading-bold-16 my-15" [innerHTML]="referenceDataLabels.GdprPrivacyTitle | localizeLabel"></div>
    <div
      class="vo-body-regular-14 vo-link-inside space-before-paragraph space-after-paragraph fs-h1-inside-24"
      [innerHTML]="referenceDataLabels.HelpCenterPrivacyContent | localizeLabel | toTrustedHtml"
    ></div>
    <kendo-dialog-actions class="d-flex justify-content-between align-items-center">
      <button class="vo-link" (click)="getGdprPdf()">
        <span class="vo-icon vo-icon-download vo-icon--16 d-inline-block mr-5"></span>
        <span [innerHTML]="referenceDataLabels.CaseOverviewRecordsActionsDownloadPdf | localizeLabel"></span>
      </button>
    </kendo-dialog-actions>
  </kendo-dialog>
</ng-container>
